'use client';

import {motion} from 'framer-motion';
import useTopStyle from '../../utils/useTopStyle';
import BookBtn from '../buttons/BookBtn/BookBtn';
import heroVariants from '../../animation/heroVariants';
import spanVariants from '../../animation/spanVariants';
import SecurityHeroSvg from '../../animation/svg-anim/SecurityHeroSvg';

const VarsHero = () => {
  const ref = useTopStyle(72);

  return (
    <motion.section
      className='security-hero'
      ref={ref}
      initial={'hidden'}
      animate={'visible'}
      transition={{
        duration: 0.7,
        delay: 0.5,
        ease: 'easeInOut'
      }}
      variants={heroVariants}
    >
      <div className='container'>
        <div className='bg-line'>
          <SecurityHeroSvg />
        </div>
        <div className='content'>
          <h2 className='title'>
            Cylerian for
            <motion.span
              className='highlight'
              initial={'hidden'}
              animate={'visible'}
              transition={{
                duration: 0.8,
                delay: 0.8,
                ease: 'easeInOut'
              }}
              variants={spanVariants}
            >
              VARs
            </motion.span>
          </h2>
          <p className='text'>{`Elevate Your Portfolio: Security as a Recurring Revenue Engine`}</p>
          <BookBtn/>
        </div>
        <div className='design'></div>
      </div>
    </motion.section>
  );
};

export default VarsHero;
